module.exports = __webpack_public_path__ + "img/priority.d486ae53.png";